import { useEffect, useState } from "react";
import { AdminNavigation } from "./AdminNavigation";
import { SMEDesignGuideline } from './SMEDesignGuideline';
import { UnitConfigurationManagement } from "./UnitConfiguration/UnitConfigurationManagement";
import { PHEPlateTypeManagement } from "./PHEPlateTypeManagement";
import { Settings } from "./Settings";
import { getLocalStorageItem, setLocalStorageItem } from "../../../Services/Global";
import { Box } from "@mui/material";

/**
 * Admin component for managing the admin settings using Material UI
 */
export const Admin: React.FC = () => {
    // Initialize with a safe default value
    const [selectedKey, setSelectedKey] = useState<string>(getLocalStorageItem('admin:currentSelection') || 'Settings');

    const handleSelection = (key: string) => {
        if (key) {
            setSelectedKey(key);
        } else {
            // Fallback to Settings if key is null or empty
            setSelectedKey('Settings');
        }
    };

    useEffect(() => {
        if (selectedKey) {
            setLocalStorageItem('admin:currentSelection', selectedKey);
        }
    }, [selectedKey]);

    // Determine which component to render based on selectedKey
    const renderContent = () => {
        const key = selectedKey || 'Settings'; // Fallback if null
        
        switch (key) {
            case 'UnitConfigurationManagement':
                return <UnitConfigurationManagement />;
            case 'PHEPlateTypeManagement':
                return <PHEPlateTypeManagement />;
            case 'SMEDesignGuideline':
                return <SMEDesignGuideline />;
            case 'Settings':
            default:
                return <Settings />;
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <AdminNavigation updateSelection={handleSelection} />
            {renderContent()}
        </Box>
    );
} 